import React from 'react';
import { Edit } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { OrderStatusBadge } from './OrderStatusBadge';

export const OrdersTab = ({ orders, onEditOrder }) => (
  <Card className="bg-purple-800/50 border-purple-600">
    <CardHeader>
      <CardTitle className="text-white">Order Management</CardTitle>
    </CardHeader>
    <CardContent>
      {orders.length > 0 ? (
        <div className="space-y-4">
          {orders.map((order) => (
            <div
              key={order.order_number}
              className="bg-purple-900/50 rounded-lg p-4 border border-purple-700"
            >
              <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                <div>
                  <p className="text-white font-semibold">{order.order_number}</p>
                  <p className="text-purple-300 text-sm">
                    {order.customer?.name} - {order.customer?.email}
                  </p>
                  <p className="text-purple-400 text-xs">
                    {new Date(order.created_at).toLocaleDateString()}
                  </p>
                </div>
                <div className="flex items-center gap-4">
                  <OrderStatusBadge status={order.status} />
                  <span className="text-yellow-400 font-bold">
                    ${order.pricing?.total?.toFixed(2)}
                  </span>
                  <Button
                    size="sm"
                    onClick={() => onEditOrder(order)}
                    className="bg-purple-700 hover:bg-purple-600"
                    data-testid={`edit-order-${order.order_number}`}
                  >
                    <Edit className="w-4 h-4" />
                  </Button>
                </div>
              </div>
              {order.tracking_number && (
                <p className="text-purple-200 text-sm">
                  Tracking: {order.carrier} - {order.tracking_number}
                </p>
              )}
              <div className="border-t border-purple-700 pt-3 mt-3">
                <p className="text-purple-200 text-sm mb-2">Items:</p>
                {order.items?.map((item, idx) => (
                  <div
                    key={`${order.order_number}-item-${idx}`}
                    className="flex justify-between text-sm text-purple-300"
                  >
                    <span>
                      {item.name} ({item.size}) x{item.quantity}
                    </span>
                    <span>${(item.price * item.quantity).toFixed(2)}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-purple-300 text-center py-8">No orders yet</p>
      )}
    </CardContent>
  </Card>
);
